<template>
    <div class="payment-wrapper">
        <van-floating-panel v-model:height="height" :anchors="anchors" class="payment-method">
            <div class="p-3">
                <div class="mb-3">
                    <h5>Paying width account:</h5>
                </div>
                <div class="mb-3">
                    <div class="cs-card-payment">
                        <p class="mb-0 font-size-16">Saving Account</p>
                        <p class="mb-0 font-size-14" :style="{ color: '#00000099' }">000 123 568 | USD</p>
                    </div>
                    <div class="cs-card-payment">
                        <p class="mb-0 font-size-16">Saving Account</p>
                        <p class="mb-0 font-size-14" :style="{ color: '#00000099' }">000 123 568 | USD</p>
                    </div>
                    <div class="cs-card-payment">
                        <p class="mb-0 font-size-16">Saving Account</p>
                        <p class="mb-0 font-size-14" :style="{ color: '#00000099' }">000 123 568 | USD</p>
                    </div>
                    <div class="cs-card-payment">
                        <p class="mb-0 font-size-16">Saving Account</p>
                        <p class="mb-0 font-size-14" :style="{ color: '#00000099' }">000 123 568 | USD</p>
                    </div>
                    <div class="cs-card-payment">
                        <p class="mb-0 font-size-16">Saving Account</p>
                        <p class="mb-0 font-size-14" :style="{ color: '#00000099' }">000 123 568 | USD</p>
                    </div>               
                </div> 
            </div>
        </van-floating-panel>
    </div>
</template>

<script>
import { FloatingPanel } from 'vant';
export default {
    name: "PaymentMethod",
    components: {
        [FloatingPanel.name]: FloatingPanel,
    },
    data() {
        return {
            anchors: [
                300,
                Math.round(0.4 * window.innerHeight),
                Math.round(0.7 * window.innerHeight),
            ],
            height: 100,
        };
    },
    mounted() {
        // Cập nhật height nếu muốn theo anchor
        this.height = this.anchors[0];
    },
    methods: {

    }
}
</script>
<style scoped>
.payment-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
}

.payment-method {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.cs-card-payment {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    padding: 15px 25px;
    border-left: 10px solid #3E7BFA;
    margin-bottom: 10px;
}
</style>
